import { render, staticRenderFns } from "./court-select.vue?vue&type=template&id=547f3753&"
import script from "./court-select.vue?vue&type=script&lang=ts&"
export * from "./court-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "court-select.vue"
export default component.exports